
import WidgetType from '@/enums/WidgetType';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['brandCode']),
    ...mapState('widget', ['widget', 'cremaDomainPrefix', 'appBuilderType']),
    ...mapState('window', ['windowService']),
    environment() {
      switch (this.cremaDomainPrefix) {
        case 'a':
          return 'STAGING-A';
        case 'b':
          return 'STAGING-B';
        case 's':
          return 'STAGING';
        case 't':
          return 'TEST';
        case 'l':
          return 'LOCAL';
        case 'd':
          return 'DEVELOP';
        default:
          return '';
      }
    },
    widgetSettingsUrl() {
      let path_by_widget_type;
      switch (this.widget.widget_type) {
        case WidgetType.PRODUCT_REVIEWS:
          path_by_widget_type = '';
          break;
        case WidgetType.REVIEWS:
          path_by_widget_type = '/reviews';
          break;
        case WidgetType.SWITCHER:
          path_by_widget_type = '/switcher';
          break;
        case WidgetType.PRODUCTS:
          path_by_widget_type = '/products';
          break;
        case WidgetType.CATEGORY_REVIEWS:
          path_by_widget_type = '/category_reviews';
          break;
        case WidgetType.MANAGING_REVIEWS:
          path_by_widget_type = '/etc';
          break;
        default:
          path_by_widget_type = '';
      }
      const params = `?widget_id=${this.widget.id}&brand_code=${this.brandCode}`;
      return `${window.location.protocol}//${this.cremaDomainPrefix}admin.cre.ma/v2/review/settings/widgets${path_by_widget_type}${params}`;
    },
    widgetInfoWatermarkShowable() {
      return (
        Object.keys(this.$route.query).includes('crema_w') && this.widget.id
      );
    }
  },
  methods: {
    clickTestServerWatermark() {
      this.windowService.alert(`
        appBuilderType: ${this.appBuilderType}
        userAgent: ${window.navigator.userAgent}
        url: ${window.location.href}
      `);
    }
  }
};
